var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImcPreobesidad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 169,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 44,
    cy: 165,
    rx: 44,
    ry: 4,
    fill: "#FBA240"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.28 0c-7.737 0-14.03 6.292-14.03 14.03.003 7.784 6.295 14.028 14.03 14.028 7.784 0 14.094-6.244 14.094-14.029C58.374 6.292 52.064 0 44.279 0zM25.267 32.254c-4.43.61-8.316 1.968-11.57 4.159-4.574 3.077-7.628 7.622-9.51 12.664C.424 59.161.488 71.55.488 85.51a5.507 5.507 0 1 0 11.013 0c0-13.877.381-25.556 3.004-32.581 1.31-3.513 2.968-5.782 5.342-7.38.457-.307.985-.576 1.525-.84-2.195 8.19-4.495 19.311-4.495 30.226 0 13.548 3.533 19.778 6.015 22.523v57.259a8.921 8.921 0 0 0 5.474 8.352 8.917 8.917 0 0 0 12.357-8.352v-50.855c0-4.418 7.182-4.418 7.182 0v50.855a8.921 8.921 0 0 0 5.475 8.352 8.917 8.917 0 0 0 12.357-8.352V97.454c2.482-2.747 6.01-8.979 6.01-22.52 0-10.914-2.3-22.036-4.494-30.225.539.264 1.067.533 1.524.84 2.374 1.598 4.032 3.867 5.343 7.38 2.622 7.025 3.003 18.704 3.003 32.581a5.508 5.508 0 1 0 11.013 0c0-13.96.065-26.349-3.7-36.433-1.881-5.042-4.936-9.587-9.51-12.664-3.254-2.19-7.14-3.549-11.57-4.16H25.268z",
    fill: "#FBA240"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImcPreobesidad);
export default __webpack_public_path__ + "static/media/IMC_Preobesidad.92716b1a.svg";
export { ForwardRef as ReactComponent };